import styled, { createGlobalStyle } from "styled-components";
import { Link } from "gatsby";

export const GlobalStyle = createGlobalStyle`
    html, body, #___gatsby, #___gatsby > div
    {
        height: 100%;
        width: 100%;
    }
`;

export const StyledLayout = styled.div`
    font-family: Montserrat;
    font-size: 14px;
    width: 100%;
    height: 100%;
`;

export const StyledLink = styled(Link).attrs({
    className: "text-sm uppercase text-gray-800 hover:text-red-600 mx-3 lg:mx-6 md:block hidden",
})``;
